<div class="container">

  <h2>Cinema</h2>

  <div class="input-group mb-3">
    <div class="form-floating">
      <input [(ngModel)]="urlAdoroCinema" class="form-control" id="urlAdoroCinema"
        placeholder="URL do AdoroCinema" (keydown.enter)="extrair()">
      <label for="urlAdoroCinema">URL do AdoroCinema (ex.: https://www.adorocinema.com/filmes/filme-29718/)</label>
    </div>
    <button type="button" class="btn btn-outline-primary" (click)="extrair()"
      [disabled]="extraindo || !urlAdoroCinema.trim()">
      @if (extraindo) {
        <span class="spinner-border spinner-border-sm me-1"></span>
      }
      Extrair
    </button>
  </div>

  <form [formGroup]="form" (ngSubmit)="salvar()">

    <div class="form-floating mb-3">
      <input formControlName="titulo" class="form-control" id="titulo" placeholder="Título">
      <label for="titulo">Título</label>
      @if (form.get('titulo')?.invalid && form.get('titulo')?.touched) {
        <small class="text-danger">Título é obrigatório.</small>
      }
    </div>

    <div class="form-floating mb-3">
      <input formControlName="tituloOriginal" class="form-control" id="tituloOriginal" placeholder="Título Original">
      <label for="tituloOriginal">Título Original</label>
    </div>

    <div class="row">
      <div class="col-md-3 mb-3">
        <div class="form-floating">
          <input formControlName="anoLancamento" type="number" class="form-control" id="anoLancamento" placeholder="Ano de Lançamento">
          <label for="anoLancamento">Ano de Lançamento</label>
          @if (form.get('anoLancamento')?.invalid && form.get('anoLancamento')?.touched) {
            <small class="text-danger">Ano é obrigatório.</small>
          }
        </div>
      </div>
      <div class="col-md-9 mb-3">
        <div class="form-floating">
          <input formControlName="direcao" class="form-control" id="direcao" placeholder="Direção">
          <label for="direcao">Direção</label>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label d-block">Avaliação</label>
      <div class="star-picker">
        @for (star of stars; track star) {
          <button type="button" class="star-btn" (click)="onStarClick($event, star)"
            [attr.aria-label]="'Avaliar com ' + star + ' estrela(s)'">
            <i class="bi" [ngClass]="starIconClass(star)"></i>
          </button>
        }
      </div>
      <small class="text-muted">Clique na metade esquerda da estrela para meia nota.</small>
    </div>

    <div class="form-floating mb-3">
      <textarea formControlName="descricaoCurta" class="form-control" id="descricaoCurta" placeholder="Descrição Curta"
        style="height: 80px"></textarea>
      <label for="descricaoCurta">Descrição Curta</label>
      @if (form.get('descricaoCurta')?.invalid && form.get('descricaoCurta')?.touched) {
        <small class="text-danger">Descrição curta é obrigatória.</small>
      }
    </div>

    <div class="form-floating mb-3">
      <textarea formControlName="descricao" class="form-control" id="descricao" placeholder="Descrição"
        style="height: 150px"></textarea>
      <label for="descricao">Descrição</label>
    </div>

    <div class="mb-3">
      <label class="form-label d-block">Elenco</label>
      <mat-chip-grid #chipGrid aria-label="Elenco">
        @for (ator of elencoTags; track ator) {
          <mat-chip-row (removed)="removeTag(ator)">
            {{ ator }}
            <button matChipRemove aria-label="Remover ator">
              <i class="bi bi-x"></i>
            </button>
          </mat-chip-row>
        }
        <input
          placeholder="Nome do ator/atriz e Tab..."
          [matChipInputFor]="chipGrid"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="true"
          (matChipInputTokenEnd)="addTag($event)">
      </mat-chip-grid>
      <small class="text-muted">Digite o nome e pressione Tab, Enter ou vírgula para adicionar.</small>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label d-block">Thumbnail</label>
        <input type="file" class="form-control" accept="image/*" (change)="onThumbnailChange($event)">
        @if (thumbnailPreview) {
          <img [src]="thumbnailPreview" class="img-preview mt-2">
        }
      </div>
      <div class="col-md-6 mb-3">
        <label class="form-label d-block">Imagem Grande</label>
        <input type="file" class="form-control" accept="image/*" (change)="onImagemGrandeChange($event)">
        @if (imagemGrandePreview) {
          <img [src]="imagemGrandePreview" class="img-preview mt-2">
        }
      </div>
    </div>

    <div class="d-flex gap-2 mt-3">
      <button type="submit" class="btn btn-primary" [disabled]="salvando">
        @if (salvando) {
          <span class="spinner-border spinner-border-sm me-1"></span>
        }
        Salvar
      </button>
      <button type="button" (click)="novo()" class="btn btn-secondary">Novo</button>
    </div>
  </form>

  <hr>

  <table mat-table [dataSource]="dataSource" matSort class="mt-2">
    <ng-container matColumnDef="thumbnail">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        @if (element.thumbnail) {
          <img [src]="getImagemUrl(element.thumbnail)" class="thumb-cell">
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="titulo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Título">
        Título
      </th>
      <td mat-cell *matCellDef="let element">{{ element.titulo }}</td>
    </ng-container>

    <ng-container matColumnDef="anoLancamento">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Ano"
        class="d-none d-lg-table-cell">
        Ano
      </th>
      <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell">{{ element.anoLancamento }}</td>
    </ng-container>

    <ng-container matColumnDef="direcao">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Direção"
        class="d-none d-lg-table-cell">
        Direção
      </th>
      <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell">{{ element.direcao }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <div class="btn-group" role="group">
          <button class="btn btn-sm" (click)="editar(row)"><i class="bi bi-pen-fill"></i></button>
          <button class="btn btn-sm" (click)="remover(row.id)"><i class="bi bi-trash"></i></button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Selecione a página">
  </mat-paginator>

</div>
